import { render, staticRenderFns } from "./mediatorList.vue?vue&type=template&id=1ed032b6&scoped=true&"
import script from "./mediatorList.vue?vue&type=script&lang=js&"
export * from "./mediatorList.vue?vue&type=script&lang=js&"
import style0 from "./mediatorList.vue?vue&type=style&index=0&id=1ed032b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed032b6",
  null
  
)

export default component.exports